import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const TermsModal = ({ open, onClose, onAccept }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-cyan-600">
            Terms & Conditions
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 text-sm text-gray-700">
          <section>
            <h3 className="font-bold text-lg mb-2">1. Acceptance of Terms</h3>
            <p>
              By using FixOurIndia platform and making a donation, you agree to be bound by these 
              Terms and Conditions. If you do not agree with any part of these terms, please do not 
              use our platform or make donations.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">2. Donation Policy</h3>
            <p className="mb-2">
              <strong>2.1 Purpose:</strong> Donations are used exclusively for resolving the reported 
              civic issues. Funds are allocated to verified vendors and contractors for work execution.
            </p>
            <p className="mb-2">
              <strong>2.2 Minimum Amount:</strong> The minimum donation amount is ₹10 (Ten Indian Rupees).
            </p>
            <p className="mb-2">
              <strong>2.3 Payment Processing:</strong> All payments are processed through Razorpay. 
              We do not store your credit card or banking information.
            </p>
            <p className="mb-2">
              <strong>2.4 GST:</strong> Donations are currently GST-exempt. If GST becomes applicable, 
              it will be clearly indicated before payment.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">3. Refund Policy</h3>
            <p className="mb-2">
              <strong>3.1 Before 80% Funding:</strong> Donors can request refunds before a report 
              reaches 80% of its funding goal. Refunds require moderator approval and must be 
              requested at least 24 hours after the donation.
            </p>
            <p className="mb-2">
              <strong>3.2 After 80% Funding:</strong> Once a report reaches 80% of its funding goal, 
              refunds are only available through manual review. Please raise a support ticket for 
              refund consideration.
            </p>
            <p className="mb-2">
              <strong>3.3 Completed Work:</strong> No refunds are available for reports where work 
              has been completed.
            </p>
            <p className="mb-2">
              <strong>3.4 Processing Time:</strong> Approved refunds are processed within 7-10 
              business days.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">4. User Responsibilities</h3>
            <p className="mb-2">
              <strong>4.1 Accurate Information:</strong> You agree to provide accurate and truthful 
              information when creating reports and making donations.
            </p>
            <p className="mb-2">
              <strong>4.2 Appropriate Content:</strong> You will not post offensive, fraudulent, or 
              misleading content on the platform.
            </p>
            <p className="mb-2">
              <strong>4.3 Account Security:</strong> You are responsible for maintaining the 
              confidentiality of your account credentials.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">5. Data Privacy</h3>
            <p className="mb-2">
              <strong>5.1 Information Collection:</strong> We collect your phone number, name, location, 
              and IP address for transaction purposes and fraud prevention.
            </p>
            <p className="mb-2">
              <strong>5.2 Data Usage:</strong> Your data is used solely for platform operations and 
              will not be sold to third parties.
            </p>
            <p className="mb-2">
              <strong>5.3 Invoice Records:</strong> We maintain invoices and transaction records for 
              legal compliance and tax purposes.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">6. Platform Usage</h3>
            <p className="mb-2">
              <strong>6.1 Report Limits:</strong> Users are limited to 5 report submissions per day 
              to prevent spam.
            </p>
            <p className="mb-2">
              <strong>6.2 Moderation:</strong> All reports are subject to moderator approval before 
              being made public and eligible for donations.
            </p>
            <p className="mb-2">
              <strong>6.3 Content Rights:</strong> By submitting content (reports, photos, comments), 
              you grant FixOurIndia a non-exclusive license to display and distribute this content.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">7. Disclaimers</h3>
            <p className="mb-2">
              <strong>7.1 No Guarantee:</strong> While we strive to resolve all reported issues, 
              we cannot guarantee the completion of work for every report.
            </p>
            <p className="mb-2">
              <strong>7.2 Third-Party Services:</strong> We are not responsible for delays or issues 
              caused by third-party vendors or government authorities.
            </p>
            <p className="mb-2">
              <strong>7.3 Platform Availability:</strong> We do not guarantee uninterrupted access 
              to the platform.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">8. Termination</h3>
            <p>
              We reserve the right to suspend or terminate accounts that violate these terms or 
              engage in fraudulent activity.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">9. Governing Law</h3>
            <p>
              These Terms and Conditions are governed by the laws of India. Any disputes shall be 
              subject to the exclusive jurisdiction of courts in New Delhi, India.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-lg mb-2">10. Contact</h3>
            <p>
              For questions about these terms, please contact us at: <br />
              <strong>Email:</strong> support@fixourindia.org <br />
              <strong>Address:</strong> New Delhi, India
            </p>
          </section>

          <section className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
            <p className="font-semibold">
              Last Updated: November 27, 2025
            </p>
            <p className="text-xs mt-2">
              We may update these terms from time to time. Continued use of the platform constitutes 
              acceptance of updated terms.
            </p>
          </section>
        </div>

        <div className="flex gap-4 mt-6">
          <Button
            onClick={onAccept}
            className="flex-1 bg-cyan-600 hover:bg-cyan-700"
          >
            I Accept
          </Button>
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsModal;
